const inkeep_ai_bot = {
    intro_message: "Merhaba, ben Logto AI!\n\nBelgelere, yardımcı makalelere ve diğer içeriklere dayalı olarak eğitilmiş bir AI asistanıyım.\n\n'Logto' hakkında bana her şeyi sorabilirsin.",
    chat_placeholder: "Adım adım bir kılavuz için Logto AI'ya sorunu sor",
    disclaimer_label: 'Logto AI feragatnamesi',
    disclaimer_tooltip: 'Yanıtlar yapay zeka tarafından üretilmiştir ve doğrulama gerektirebilir.',
    example_questions_label: 'Örnek sorular',
    example_questions: [
        'Logto kurulumu için hızlı başlangıç ​​kılavuzu',
        'Çoklu kiracı mimarisini yapılandırma',
        'Kullanıcı profilini nasıl entegre edebilirim?',
    ],
    stop: 'Durdur',
    clear: 'Baştan başla',
    get_help: 'Yardım al',
    copy_chat: 'Kopyala',
    ask_ai_label: 'AI’a Sor',
    contact: 'İletişim',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
